import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerBody, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions, useFormState } from 'utils/hooks';
import * as cpFormsActions from 'store/cp-forms/actions';
import Body from './Body';
import config from './config';

const EditCpForm = ({ drawer, refetchData, active }) => {
  const [disabled, setDisabled] = useState(false);
  const [updateCpForm, createCpForm] = useActions([
    cpFormsActions.updateCpForm,
    cpFormsActions.createCpForm
  ]);
  const { formState, loadValues, collectValues, resetForm } = useForm(config);
  const { fields } = useFormState(formState);

  useEffect(() => {
    if (active) {
      loadValues({
        ...active
      });
    } else {
      resetForm();
    }
  }, [active, drawer.isOpen]);

  const submit = () => {
    const values = collectValues();
    setDisabled(true);
    if (!values) {
      setDisabled(false);
      return;
    }
    if (active) {
      const params = {
        ...values,
        id: active.id
      };
      updateCpForm({ table: 'cp_forms', ...params }).then(() => [
        setDisabled(false),
        drawer.close()
      ]);
    } else {
      createCpForm(values).then(() => [setDisabled(false), drawer.close(), refetchData()]);
    }
  };

  const hasErrors = !Object.keys(fields)
    .map(field => fields[field].error)
    .filter(field => field).length;

  return (
    <Drawer {...drawer}>
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit' : 'Create CP Form'} {active ? active.short_name : null}
      </DrawerHeader>
      <DrawerBody className="pt-3">
        <FormDrawer>
          <Body formState={formState} />
        </FormDrawer>
      </DrawerBody>
      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => {
            drawer.close();
          }}
          disabled={disabled}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={disabled || !hasErrors} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditCpForm;
